import styled from 'styled-components';
export const IconsContainer = styled.div.withConfig({
  displayName: "EditControlsstyle__IconsContainer"
})(["position:absolute;width:", ";height:", ";margin-top:", ";right:0;transition:opacity 0.3s;display:flex;align-items:center;opacity:", ";cursor:pointer;top:", ";"], ({
  theme
}) => theme.space['500'], ({
  theme
}) => theme.space['500'], ({
  marginTop,
  theme
}) => marginTop ? `${marginTop}px` : theme.space['100'], ({
  opacity
}) => opacity !== null && opacity !== void 0 ? opacity : '1', ({
  errorMessage
}) => errorMessage ? '33%' : '50%');
export const SuccessUIIconWrapper = styled.div.withConfig({
  displayName: "EditControlsstyle__SuccessUIIconWrapper"
})(["cursor:", ";opacity:", ";"], ({
  canSave
}) => canSave ? 'pointer' : 'not-allowed', ({
  canSave
}) => canSave ? 1 : 0.5);
export const CancelUIIconWrapper = styled.div.withConfig({
  displayName: "EditControlsstyle__CancelUIIconWrapper"
})(["cursor:pointer;"]);